<div class="main-container">
    <div class="qb-header">
        <div class="module-heading">
            Badges
        </div>
    </div>
    <div class="card-cont">
        <div class="b-text">Enhance customer engagement with achievement-based badges.</div>
        <div class="c-text">
            Badges recognize and reward customers for their loyalty and interactions. Setup your badge and rewards to encourage repeat purchases and brand advocacy. 
        </div>
    </div>
    <!-- <div class="row-sp margin-top-st">
        <div class="card-cont-2">
            <div class="card-title">
                <div class="icon-big">
                    <span class="material-symbols-outlined big-icon"> list_alt_check </span>
                </div>
                <div class="semi-big-text">
                    Set Up Spin Criteria
                </div>
            </div>
            <div class="card-content">
                Define the actions customers need to complete to earn a spin.
            </div>
        </div>
        <div class="card-cont-2">
            <div class="card-title">
                <div class="icon-big">
                    <span class="material-symbols-outlined big-icon"> settings </span>
                </div>
                <div class="semi-big-text">
                    Customize Rewards
                </div>
            </div>
            <div class="card-content">
                Design the reward segments on the wheel, offering prizes like discounts, loyalty points, or exclusive perks.
            </div>
        </div>
        <div class="card-cont-2">
            <div class="card-title">
                <div class="icon-big">
                    <span class="material-symbols-outlined big-icon">query_stats</span>
                </div>
                <div class="semi-big-text">
                    Track Participation
                </div>
            </div>
            <div class="card-content">
                Get insights into how often customers spin the wheel, what rewards are redeemed, and how it impacts sales and loyalty.
            </div>
        </div>
    </div> -->
    <div class="main-white-panel custom-panel m-h-400">
        <div class="d-flex align-items-center col-sm-12 mb-2">
            <div class="search-container col-sm-6 col-md-5 me-3" *ngIf="originalBadgeList.length > 5">
                <input
                    #search
                    type="text"
                    placeholder="Search by Badge Name"
                    (input)="onKeySearch()"
                    [(ngModel)]="listSearch"
                />
                <span class="material-icons icons-primary" *ngIf="search.value.length==0"> search </span>
                <span class="material-icons icons-primary cursor-pointer" *ngIf="search.value.length>0" (click)="resetSearch()">
                    close
                </span>
            </div>
            <button class="primary-button create-button-style button-hover-effect" (click)="openCreateDialog('create')"
             [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
                Create Badge
            </button>
        </div>
        <div class="listing-container">
            <div class="list-column-header-row">
                <div class="col-header">
                    Badge Name
                </div>
                <div class="col-header narrow-column-width">
                    Created At
                </div>
                <div class="col-header narrow-column-width">
                    Badge Owners
                </div>
                <div class="col-header narrow-column-width">
                    Actions
                </div>
            </div>
            <div class="main-list">
                <div class="list-loader-container" *ngIf="isDataLoading">
                    <app-qubriux-loading  [size]="65" [loadingText]="'Fetching your list...'"></app-qubriux-loading>
                </div>
                <div *ngIf="!isDataLoading && badgeList.length == 0" class="empty-list-indicator">
                    No Badges found
                </div>
                <div *ngIf="!isDataLoading && badgeList.length > 0">
                    <div *ngFor="let badge of badgeList" class="list-item-row">
                        <div class="list-item">
                            <div>{{badge.name}}</div>
                        </div>
                        <div class="list-item narrow-column-width">
                            <div>{{getDateInTimeZone(badge.createdAt,'date')}} | {{ getDateInTimeZone(badge.createdAt,'time')}}</div>
                        </div>
                        <div class="list-item narrow-column-width">
                            <div>{{badge.customerCountWithThisBadge}}</div>
                        </div>
                        <!-- <div class="list-item d-f-a-c" [ngClass]="{'green-text':badge.config.isActive,'grey-text':!badge.config.isActive}">
                            <div class="d-f-a-c"> 
                                <span class="material-icons icons-primary color-inherit">flag</span>
                                <span class="font-weight-600">{{badge.config.isActive?'Active':'Inactive'}}</span>
                            </div>
                            <mat-slide-toggle (change)="onToggleChange($event,badge)" [ngModel]="badge.config.isActive"></mat-slide-toggle>
                        </div> -->
                        <div class="list-item action-icon-container narrow-column-width">
                            <button class="qb-disable-button-container" [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Edit badge Configuration')"
                            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" (click)="openCreateDialog('edit',badge.id)">
                                <span class="material-symbols-outlined sp-icon-1">
                                    edit
                                </span>
                            </button>
                            <button class="qb-disable-button-container" [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Clone badge Configuration')"
                            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" (click)="openCreateDialog('clone',badge.id)">
                                <span class="material-symbols-outlined sp-icon-1" >
                                    copy_all
                                </span>
                            </button>
                            <!-- <span [matTooltip]="'View badge Configuration'" class="material-symbols-outlined sp-icon-1" (click)="previewBadge(badge.id)">
                                visibility
                            </span> -->
                            <button class="qb-disable-button-container" [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Delete badge Configuration')"
                            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" (click)=deleteBadge(badge.id)>
                                <span class="material-symbols-outlined sp-icon-1 red-text" >
                                    delete
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>